import type { ReactNode } from "react";
import { QueryProvider } from "@/app/QueryProvider";
import { PullToRefreshProvider } from "@/shared/pull-to-refresh";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <PullToRefreshProvider>{children}</PullToRefreshProvider>
    </QueryProvider>
  );
}
